var exports = {
  "nM": "xcc377c0b--ff16d9--row",
  "_8": "xcc377c0b--ff16d9--img",
  "UU": "xcc377c0b--ff16d9--name",
  "h5": "xcc377c0b--ff16d9--status",
  "O5": "xcc377c0b--ff16d9--offers",
  "nf": "xcc377c0b--ff16d9--link",
};

module.exports = exports;
